
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Mumbaitohyderabadcab() {



    const cardData =
    {
        keyword: 'Mumbai to Hyderabad Cab',
        heading: 'S9 Travels: Mumbai to Hyderabad Cab',
        headingDescription: 'S9 Travels offers Mumbai to Hyderabad Cab Service, ensuring a comfortable, reliable, and hassle-free journey. Whether you are traveling for business, leisure, or family visits, our Innova cabs provide a smooth and safe ride. With spacious interiors, luxury features, and professional drivers, we guarantee a stress-free travel experience. Enjoy on-time pickups, affordable pricing, and 24/7 service. Book your Mumbai to Hyderabad cab with S9 Travels for a seamless and enjoyable road trip!',


        top: 'Top Places to Visit in Hyderabad with S9 Travels',

"topPlaces": [
    {
      "title": "Charminar",
      "description": "One of Hyderabad’s most iconic landmarks, Charminar is a majestic structure built in 1591 by Sultan Muhammad Quli Qutb Shah. This grand monument, featuring four towering minarets, is a symbol of Hyderabad's rich history and Indo-Islamic architecture. Surrounded by bustling markets, including the famous Laad Bazaar, it’s a must-visit for those looking to explore the city’s heritage and culture."
    },
    {
      "title": "Golconda Fort",
      "description": "An architectural marvel, Golconda Fort is a historic fortress known for its incredible acoustics, massive gates, and beautiful palaces. Built during the Kakatiya dynasty and later expanded by the Qutb Shahi rulers, the fort offers breathtaking views of Hyderabad from the top. Don't miss the mesmerizing evening light and sound show that narrates the fort’s glorious past."
    },
    {
      "title": "Ramoji Film City",
      "description": "Spanning over 2,000 acres, Ramoji Film City is the world’s largest film studio complex and a popular tourist attraction. Visitors can explore grand movie sets, enjoy thrilling rides, and witness live shows. It’s a paradise for movie buffs and an ideal destination for a fun-filled day with family and friends."
    },
    {
      "title": "Hussain Sagar Lake",
      "description": "A beautiful artificial lake built in 1563, Hussain Sagar is famous for the gigantic Buddha statue standing on an island in the middle. Visitors can enjoy boat rides, take a leisurely walk along the Necklace Road, or relax at Lumbini Park, which offers a stunning view of the illuminated lake at night."
    },
    {
      "title": "Salar Jung Museum",
      "description": "Home to one of the world's largest private collections of art and artifacts, Salar Jung Museum showcases an incredible range of exhibits from India, Europe, the Middle East, and beyond. Highlights include the famous Veiled Rebecca statue, exquisite Mughal-era paintings, rare manuscripts, and antique clocks."
    },
    {
      "title": "Birla Mandir",
      "description": "Situated on a hilltop, Birla Mandir is a magnificent white marble temple dedicated to Lord Venkateswara. The temple's intricate carvings, peaceful surroundings, and panoramic views of Hyderabad make it a perfect spot for spiritual seekers and photography enthusiasts alike."
    },
    {
      "title": "Chowmohalla Palace",
      "description": "Once the official residence of the Nizams of Hyderabad, Chowmohalla Palace is a stunning example of Mughal and Persian architecture. This opulent palace complex features grand halls, vintage cars, and priceless antiques that provide a glimpse into the luxurious lifestyle of the Nizams."
    },
    {
      "title": "Nehru Zoological Park",
      "description": "Spread over 380 acres, Nehru Zoological Park is one of India’s largest and most well-maintained zoos. Home to a wide variety of animals, including tigers, elephants, and exotic birds, the zoo offers safari rides and a large aquarium, making it a favorite destination for families and wildlife lovers."
    },
    {
      "title": "Qutb Shahi Tombs",
      "description": "Located near Golconda Fort, the Qutb Shahi Tombs are an architectural wonder featuring intricately carved stone tombs of the Qutb Shahi rulers. Surrounded by lush gardens, these tombs beautifully showcase Persian and Indo-Islamic styles, making them a fascinating historical site to explore."
    },
    {
      "title": "Shilparamam",
      "description": "A cultural and arts village in Hyderabad, Shilparamam is a great place to experience the region’s traditional crafts, folk performances, and exhibitions. This vibrant venue offers a unique shopping experience where visitors can buy handcrafted items, jewelry, and textiles directly from artisans."
    }
],

"services": [
    {
      "name": "Mumbai to Hyderabad Cab Service",
      "description": "Travel comfortably from Mumbai to Hyderabad with S9 Travels. Our reliable and professional taxi service ensures a smooth and enjoyable journey, whether it's a one-way trip or a round trip."
    },
    {
      "name": "Book Mumbai to Hyderabad Taxi",
      "description": "Booking a taxi from Mumbai to Hyderabad is quick and easy with S9 Travels. Enjoy a hassle-free ride in a well-maintained vehicle with a professional driver."
    },
    {
      "name": "Affordable Mumbai to Hyderabad Cab",
      "description": "Looking for an affordable taxi from Mumbai to Hyderabad? S9 Travels offers competitive pricing without compromising on the quality of service, ensuring you get the best value for your journey."
    },
    {
      "name": "Private Taxi for Hyderabad from Mumbai",
      "description": "Book a private taxi for a personalized travel experience from Mumbai to Hyderabad. Our private cabs offer comfort, convenience, and privacy for your long journey."
    },
    {
      "name": "Mumbai to Hyderabad One-Way or Round Trip",
      "description": "Whether you're planning a one-way trip or a round trip, S9 Travels offers flexible taxi services for your journey from Mumbai to Hyderabad. Choose the option that best suits your travel needs."
    },
    {
      "name": "Hyderabad Trip by Cab from Mumbai",
      "description": "Explore Hyderabad with ease by booking a cab from Mumbai. Our experienced drivers will take you to the city's key attractions, ensuring a pleasant trip throughout."
    },
    {
      "name": "Luxury Taxi from Mumbai to Hyderabad",
      "description": "Travel in luxury from Mumbai to Hyderabad with our premium taxi service. Enjoy a comfortable ride in a luxury vehicle, equipped with top-tier amenities for a high-end experience."
    },
    {
      "name": "Group Travel to Hyderabad",
      "description": "Planning a group trip to Hyderabad? S9 Travels offers spacious cabs that can comfortably accommodate your group, ensuring a comfortable and enjoyable ride for everyone."
    },
    {
      "name": "Comfortable Mumbai to Hyderabad Taxi Service",
      "description": "Experience comfort and convenience on your trip from Mumbai to Hyderabad. Our well-maintained cabs and professional drivers ensure a smooth, stress-free journey."
    },
    {
      "name": "Hyderabad Holiday by Private Taxi",
      "description": "Make your Hyderabad holiday unforgettable by booking a private taxi from Mumbai. Enjoy a relaxed, stress-free trip with personalized services and a professional driver."
    }
],

"tableData": [
  ["Mumbai to Hyderabad Cab Service", "Book Mumbai to Hyderabad Taxi"],
  ["Affordable Mumbai to Hyderabad Cab", "Private Taxi for Hyderabad from Mumbai"],
  ["Mumbai to Hyderabad One-Way or Round Trip", "Hyderabad Trip by Cab from Mumbai"],
  ["Luxury Taxi from Mumbai to Hyderabad", "Group Travel to Hyderabad"],
  ["Comfortable Mumbai to Hyderabad Taxi Service", "Hyderabad Holiday by Private Taxi"],
  ["", ""]
],




"whychoose": [
  {
    "WhyChooseheading": "Comfortable and Smooth Long-Distance Ride",
    "WhyChoosedescription": "S9 Travels offers a comfortable Mumbai to Hyderabad cab service, providing you with a smooth and relaxing ride. Our well-maintained vehicles, including the Toyota Innova, ensure comfort throughout the long journey, with ample legroom, air conditioning, and plush seating to make your travel experience more enjoyable."
  },
  {
    "WhyChooseheading": "Timely and Reliable Service",
    "WhyChoosedescription": "We understand the importance of timely arrivals. Our Mumbai to Hyderabad cab service ensures prompt pick-ups and drop-offs, allowing you to reach your destination on time without any delays. Whether you're traveling for business or leisure, we guarantee a reliable and punctual service."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our experienced drivers are familiar with the best routes and road conditions from Mumbai to Hyderabad. They ensure a safe and smooth journey, providing you with peace of mind throughout the trip, regardless of the distance or weather conditions."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "S9 Travels offers affordable rates for the Mumbai to Hyderabad cab service. We provide transparent pricing with no hidden charges. You'll receive a clear breakdown of costs during the booking process, making it easy to plan your travel budget with confidence."
  },
  {
    "WhyChooseheading": "Safety and Comfort Throughout the Journey",
    "WhyChoosedescription": "Your safety is our priority. All our vehicles are equipped with modern safety features such as GPS tracking, airbags, and seat belts, ensuring a secure and comfortable journey from Mumbai to Hyderabad. You can relax and enjoy your trip knowing you're in safe hands."
  },
  {
    "WhyChooseheading": "24/7 Availability for Flexible Travel",
    "WhyChoosedescription": "S9 Travels operates 24/7, offering you the flexibility to book your Mumbai to Hyderabad cab at a time that suits your travel schedule. Whether you need to leave early in the morning or return late at night, we provide flexible service to meet your needs."
  },
  {
    "WhyChooseheading": "Customizable Itinerary for Your Trip",
    "WhyChoosedescription": "We offer customizable itineraries for your Mumbai to Hyderabad journey. Whether you'd like to make stops along the way, have specific sightseeing requests, or need special arrangements, we tailor your trip to your preferences for a more personalized experience."
  },
  {
    "WhyChooseheading": "Easy and Hassle-Free Booking Process",
    "WhyChoosedescription": "Booking your Mumbai to Hyderabad cab with S9 Travels is simple and hassle-free. You can easily book online via our website or app, or contact our customer service team for personalized assistance. We ensure a quick and convenient booking experience every time."
  }
]















    }


    const faqData = [
        [
          {
            question: 'How can I book a cab from Mumbai to Hyderabad with S9 Travels?',
            answer: 'Booking a cab from Mumbai to Hyderabad is simple! You can book your ride online via our website or mobile app, or contact our customer service team for assistance. We ensure a comfortable and seamless long-distance journey.',
          },
          {
            question: 'What types of vehicles are available for Mumbai to Hyderabad travel?',
            answer: 'We offer a variety of vehicles for your journey from Mumbai to Hyderabad, including sedans, SUVs, and premium vehicles like the Toyota Innova. Choose the vehicle that best suits your needs for a smooth and enjoyable trip.',
          },
          {
            question: 'How long does the journey from Mumbai to Hyderabad take?',
            answer: 'The journey from Mumbai to Hyderabad typically takes around 16 to 18 hours, depending on road conditions and traffic. Our experienced drivers ensure your comfort with regular breaks for meals and rest during the trip.',
          },
          {
            question: 'Are the drivers experienced for long-distance travel like Mumbai to Hyderabad?',
            answer: 'Yes, our drivers are highly experienced in long-distance travel and are familiar with the best routes to Hyderabad. They prioritize your safety and comfort throughout the journey.',
          },
          {
            question: 'Can I book a round trip for Mumbai to Hyderabad?',
            answer: 'Yes, you can book a round-trip cab for your journey from Mumbai to Hyderabad. Simply provide us with your return details, and we’ll ensure a smooth and timely return trip to Mumbai.',
          },
          {
            question: 'Is there a fixed fare for Mumbai to Hyderabad cab service?',
            answer: 'The fare for Mumbai to Hyderabad cab service depends on the type of vehicle, trip duration, and specific requirements. Contact us for a customized quote, and we’ll provide you with a transparent pricing estimate.',
          },
          {
            question: 'Do you provide pick-up services from Mumbai airport or hotels for Hyderabad trips?',
            answer: 'Yes, we offer pick-up services from Mumbai airport or hotels for your trip to Hyderabad. Our driver will ensure a seamless transfer, and we’ll tailor the service to your needs.',
          },
          {
            question: 'Can I request additional stops on the way to Hyderabad?',
            answer: 'Yes, we can accommodate additional stops for meals, sightseeing, or other breaks during your journey. Let us know your preferences when booking, and we will adjust the itinerary accordingly.',
          },
          {
            question: 'Is there any extra charge for waiting or detours during the Mumbai to Hyderabad trip?',
            answer: 'Any extra charges for waiting time or detours will be communicated upfront during the booking process. We ensure full transparency in pricing, so you’ll know exactly what to expect.',
          },
          {
            question: 'Why should I choose S9 Travels for my Mumbai to Hyderabad cab service?',
            answer: 'S9 Travels provides reliable, safe, and comfortable long-distance travel services. With well-maintained vehicles, professional drivers, and excellent customer service, we ensure your journey from Mumbai to Hyderabad is smooth, safe, and enjoyable.',
          },
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Arun Reddy',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“I booked a cab from Mumbai to Hyderabad with S9 Travels, and the entire journey was amazing. The driver was professional and ensured our safety and comfort. The car was clean, and the ride was smooth despite the long distance. Highly recommend S9 Travels for long-distance travel!”',
        },
        {
          name: 'Mrs. Priya Gupta',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“Our journey from Mumbai to Hyderabad with S9 Travels was a pleasant experience. The driver was courteous, and the vehicle was comfortable, making the long trip feel much shorter. We will definitely book with them again for future travel!”',
        },
      ];
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   

      
    const productSchema = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Mumbai to Hyderabad Cab",
        "description": "Book affordable and reliable Mumbai to Hyderabad cab services for one-way trips, round trips, luxury cabs, and group travel. S9 Travels offers private taxi rides for a comfortable and scenic journey from Mumbai to Hyderabad, perfect for holidays, business trips, and sightseeing tours.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.8",
          "ratingCount": "8569"
        }
      };
      
      
      
      


    return (
        <div>
        <Helmet>
        <title>Mumbai to Hyderabad Cab | S9 Travels | Contact: +91 8850328441</title>
        <meta 
          name="description" 
          content="Book Mumbai to Hyderabad taxi services, including one-way, round-trip, and luxury cabs. Comfortable and affordable transport for sightseeing tours, business travel, and holidays from Mumbai to Hyderabad with S9 Travels." 
        />
        
        {/* Inject JSON-LD Schema */}
        <script type="application/ld+json">
          {JSON.stringify(productSchema)}
        </script>
      </Helmet>
      
      

<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/61.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Mumbaitohyderabadcab;